const mutations = {
  ubahNama: (state, paylaod) => {
    state.nama = paylaod;
  },
  addDataDashboard: (state, payload) => {
    state.dataDashboard = payload;
  },
  addDataOtp: (state, payload) => {
    state.dataOtp = payload;
  },
  addDataLayanan: (state, payload) => {
    state.dataLayanan = payload;
  },
};
export default mutations;
